function Str(props) {
    return (
        <p className="str">{props.data}</p>
    )
}

export default Str